import {
  IconButton,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import React, { useState } from 'react';
import { INTEGRATIONS_SERVER_VIEW } from '../../../../constants/IntegrationsConst';
import CustomCountBox from '../../../../shared/custom-count-box/Custom-Count-Box';
import TablePaginationActions from '../../../../shared/table-pagination/TablePaginationActions';

const IntegrationsList = (props) => {
  const { onViewToggle, selectedHotel, permissions } = props;
  const [searchText, setSearchText] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [integrationServerList, setIntegrationServerList] = useState([]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onViewDetails = (category, e) => {
    if (
      e.target.className === 'MuiTableCell-root MuiTableCell-body' ||
      e.target.className === 'MuiTableCell-root MuiTableCell-body MuiTableCell-alignCenter' ||
      e.target.className === 'MuiTableCell-root MuiTableCell-body MuiTableCell-alignRight' ||
      e.target.className === 'custom-chip' ||
      e.target.className === 'MuiChip-label'
    ) {
      onViewToggle(INTEGRATIONS_SERVER_VIEW, true, category);
    }
  };

  return (
    <div>
      <div className='row m-2 d-flex mt-3'>
        <div className='col-md-4'>
          <TextField
            className='w-100'
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            label='Search'
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div className='col text-secondary align-self-end mb-1 ms-3'>
          Showing results for last 30 days, for all the requests.
        </div>
      </div>
      <div className='mt-4'>
        <CustomCountBox
          customBoxSmall={true}
          count={{ name: 'Total Requests', count: '50' }}
          disableIcon={true}
          className={'border border-dark ms-3'}
        />
        <CustomCountBox
          customBoxSmall={true}
          count={{ name: 'Successful', count: '31', countColor: '#1AA27B' }}
          disableIcon={true}
          className={'ms-3'}
        />
        <CustomCountBox
          customBoxSmall={true}
          count={{ name: 'In-Progress', count: '11', countColor: '#F7B538' }}
          disableIcon={true}
          className={'ms-3'}
        />
        <CustomCountBox
          customBoxSmall={true}
          count={{ name: 'Failed', count: '08', countColor: '#EE3253' }}
          disableIcon={true}
          className={'ms-3'}
        />
        <CustomCountBox
          customBoxSmall={true}
          count={{ name: 'Cancelled', count: '00', countColor: '#6B6B6B' }}
          disableIcon={true}
          className={'ms-3'}
        />
      </div>
      <div className='mt-4'>
        <TableContainer className='housekeeping-list-table'>
          <Table className='list-table' aria-label='simple table'>
            <TableHead>
              <TableRow className='border-white pointer'>
                <TableCell>Date & Time</TableCell>
                <TableCell>API</TableCell>
                <TableCell>Status Code</TableCell>
                <TableCell>Response</TableCell>
                <TableCell>Response Time</TableCell>
                <TableCell className='ps-4'>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className='pointer'>
              <TableRow
                onClick={(e) => {
                  onViewDetails('item', e);
                }}
              >
                <TableCell>23/09/2022 - 11:09:23</TableCell>
                <TableCell>Lorem Ipsum</TableCell>
                <TableCell className='ps-5'>500</TableCell>
                <TableCell>Dolor sit amet, con...</TableCell>
                <TableCell className='ps-5'>2291 ms</TableCell>
                <TableCell>Successful</TableCell>
              </TableRow>
            </TableBody>
            <TableFooter>
              <TableRow className='paginator'>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                  count={integrationServerList.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: { 'aria-label': 'rows per page' },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default IntegrationsList;
